export const itemsDiamonds = [
    {
        title: 'Building Envelope Renewal',
        image: '/assets/imgs/home/diamond/BuildingEnvelopeRenewals.jpg',
        link: "building-envelope-renewals"
    },
    {
        title: 'Commercial Exterior Painting',
        image: '/assets/imgs/home/diamond/CommercialExteriorPainting.jpg',
        link: "commercial-exterior-painting"
    },
    {
        title: 'High-Rise & Mid-Rise Projects',
        image: '/assets/imgs/home/diamond/High-Rise&Mid-RiseProjects.jpg',
        link: "high-rise-mid-rise-projects"
    },
    {
        title: 'Caulking & Sealant Renewal',
        image: '/assets/imgs/home/diamond/Caulking&SealantRenewal.jpg',
        link: "caulking-sealant-renewal"
    },
    {
        title: 'Commercial Interior Painting',
        image: '/assets/imgs/home/diamond/CommercialInteriorPainting.jpg',
        link: "commercial-interior-painting"
    },
    {
        title: 'Waterproofing Systems',
        image: '/assets/imgs/home/diamond/WaterproofingSystems.jpg',
        link: "waterproofing-systems"
    },
    {
        title: 'General Contracting',
        image: '/assets/imgs/home/diamond/GeneralContracting.jpg',
        link: "general-contracting"
    },
    {
        title: 'Concrete Restoration',
        image: '/assets/imgs/home/diamond/ConcreteRestoration.jpg',
        link: "concrete-restoration"
    },
    {
        title: 'Balcony Renewal',
        image: '/assets/imgs/home/diamond/BalconyRenewal.jpg',
        link: "balcony-renewal"
    },
    {
        title: 'Leak Investigation & Remediation',
        image: '/assets/imgs/home/diamond/LeakInvestigationandRemediation.jpg',
        link: "leak-investigation-and-remediation"
    },
    {
        title: 'Window Cleaning',
        image: '/assets/imgs/home/diamond/WindowCleaning.jpg',
        link: "windows-cleaning"
    },
    {
        title: 'Commercial Snow Removal',
        image: '/assets/imgs/home/diamond/CommercialSnowRemoval.jpg',
        link: "commercial-snow-removal"
    },
];